<template><div></div></template>

<script>
export default {
  name: 'Logout',
  created () {
    delete localStorage.token
    this.$store.commit('logout')
    this.$router.push('/')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Logout.vue